const state = () => {
  return {
    showNavigation: false
  }
}

const getters = {
  getShowNavigation: state => state.showNavigation
}

const mutations = {
  updateShowNavigation: (state, value) => {
    state.showNavigation = value
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
